import { useState } from 'react';
import ModuleSetupPage from '../../components/ModuleSetupPage';
import KpiSetupPage from './KpiSetupPage';
import GroupAssignmentPage from './GroupAssignmentPage';
import DataEntryPage from './DataEntryPage';

function LeaderboardConfigTab() {
  const [tab, setTab] = useState('kpis');

  return (
    <div>
      <div className="setup-tabs" style={{ marginBottom: 20 }}>
        <button className={`setup-tab${tab === 'kpis' ? ' active' : ''}`} onClick={() => setTab('kpis')}>KPI Setup</button>
        <button className={`setup-tab${tab === 'groups' ? ' active' : ''}`} onClick={() => setTab('groups')}>Groups</button>
        <button className={`setup-tab${tab === 'data' ? ' active' : ''}`} onClick={() => setTab('data')}>Data Entry</button>
      </div>
      {tab === 'kpis' && <KpiSetupPage />}
      {tab === 'groups' && <GroupAssignmentPage />}
      {tab === 'data' && <DataEntryPage />}
    </div>
  );
}

export default function LeaderboardModuleSetupPage() {
  return (
    <ModuleSetupPage
      moduleKey="leaderboard"
      moduleLabel="Leaderboard"
      configComponent={<LeaderboardConfigTab />}
    />
  );
}
